const APP_PREFIX = '@APP';

export const ENABLE_MOUSE_CONTROLS = `${APP_PREFIX}/ENABLE_MOUSE_CONTROLS`;

export const INIT_USER_DATA = `${APP_PREFIX}/INIT_USER_DATA`;
export const INIT_USER_DATA_SUCCESS = `${APP_PREFIX}/INIT_USER_DATA_SUCCESS`;
export const INIT_USER_DATA_ERROR = `${APP_PREFIX}/INIT_USER_DATA_ERROR`;
export const RESET_USER_DATA = `${APP_PREFIX}/RESET_USER_DATA`;
export const CHANGE_UI_LANGUAGE = `${APP_PREFIX}/CHANGE_UI_LANGUAGE`;

export const LOCATION_CHANGE = `${APP_PREFIX}/LOCATION_CHANGE`;
export const RESET_AUTH_STEPS = `${APP_PREFIX}/RESET_AUTH_STEPS`;
